import React, { useCallback } from 'react'
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import ScriptEditor from '../common/ScriptEditor';
import { useToasts } from '../../contexts/toasts';
import { Button } from 'antd';

type Props = {
  open?: boolean;
  onClose?: VoidFunction;
  entity?: any;
  label?: string;
}

export default function EntityDefinitionModal({ open, onClose, entity, label }: Props) {
  const { showToast } = useToasts();

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(JSON.stringify(entity) || "");
    showToast('text-copied', `${label} definition copied to clipboard!`);
  }, [showToast, entity, label]);

  return (
    <Modal size="lg" show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{label} {entity?.name} Definition</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="position-relative">
          <ScriptEditor value={entity} readOnly />

          <Button onClick={copyToClipboard} className="service-definition-button" icon={<FontAwesomeIcon icon={solid('clipboard')} />}>
            Copy to Clipboard
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="border" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}